import { createRef } from "react";
import { CSVLink } from "react-csv";
import ReactDOM from "react-dom";

export function downloadCSV(csvData, filename) {
  const csvRef = createRef();

  // Create an invisible container
  const container = document.createElement("div");
  container.style.display = "none";
  document.body.appendChild(container);

  // Render a CSVLink inside it
  const csvLink = (
    <CSVLink
      data={csvData}
      filename={`${filename}.csv`}
      ref={csvRef}
      target="_blank"
    ></CSVLink>
  );

  ReactDOM.render(csvLink, container, () => {
    // After rendering, trigger click
    csvRef.current?.link.click();

    // Clean up DOM
    setTimeout(() => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    }, 1000); // Give it time to download before removing
  });
}
